//域名
const domain = "//apicloud.gyyx.cn";
//新闻列表页
export const newsListUrl = `${domain}/www/news/list`;
//详情页面
export const newsDetailsUrl = `${domain}/www/news/get`;
